<template>
    <div class="xcrd" style="margin-top: 0;">
        <v-stepper v-model="e6" vertical>
            <v-btn small class="mx-4" @click="$router.back()" color="info" tile outlined>
                <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
            </v-btn>

            <h4 class="text-center mb-0"> Establecer Informacion del modulo: <span v-if="modulo.modulo"> {{ modulo.modulo.nombre }}</span> </h4>
            <p class="text-center mb-0"> En esta session puede agregar informacion del modulo actual, como ser el docente el fondo del certificado modular, el horario de clases entre otras opciones. </p>
            <p class="text-center"> {{ programa.nombre_compuesto }} </p>
            <v-stepper-step :complete="e6 > 1" step="1">
                Configurar certificado Modular y Asignar Docente 
                <small> Fondo del certificado </small>
            </v-stepper-step>

            <v-stepper-content step="1">
                <ModEdit :atras="false"/>
                <v-btn outlined color="primary" @click="e6 = 2"> Continuar </v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" step="2">
                Horario de Clases para este modulo
                <small v-if="modulo.modulo"> {{ modulo.modulo.nombre }} </small>
            </v-stepper-step>

            <v-stepper-content step="2">
                <div class="mb-4">
                    <v-data-table :loading="loading" :headers="headers" :items="desserts" :items-per-page="100" hide-default-footer :caption="modulo.modulo?`Modulo: ${modulo.modulo.nombre}`:''" class="elevation-0 mt-4" > 
                    </v-data-table>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" tile dark small color="green" v-bind="attrs" v-on="on" @click="opensessiones(modulo)">
                                <v-icon left dark small> mdi-book-clock </v-icon>
                                establecer el Horario de clases
                            </v-btn>
                        </template>
                        <span>Definir horarios de clases (Sessiones)</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" tile dark small color="green" v-bind="attrs" v-on="on" @click="openCalendario()">
                                <v-icon left dark small> mdi-calendar </v-icon>
                                Ver calendario
                            </v-btn>
                        </template>
                        <span> Visualizar el calendario de horario </span>
                    </v-tooltip>
                </div>
                <v-btn outlined color="primary" @click="e6 = 3"> Continuar </v-btn>
                <v-btn outlined color="orange" class="ml-1" @click="e6 = 1"> Retroceder </v-btn>
            </v-stepper-content> 

            <v-stepper-step :complete="e6 > 3" step="3">
                Escala salarial
            </v-stepper-step>

            <v-stepper-content step="3">
                <div>
                    Aqui la vista para la escala salarial
                </div>
                <v-btn outlined color="primary" @click="e6 = 4"> Continuar </v-btn>
                <v-btn outlined color="orange" class="ml-1" @click="e6 = 1"> Retroceder </v-btn>
            </v-stepper-content>
        </v-stepper>

        <psessiones ref="psessiones" v-on:onsaved="getHorarios"/>
        <v-dialog v-model="dialog" width="820">
            <v-card>
                <v-card-title class="text-h5 green darken-2"> </v-card-title>
                <Calendario ref="refcalendario"/>
                <div class="text-center mt-4 mb-0">
                    <v-btn outlined color="purple" class="ml-1" @click="dialog = false"> Cerrar </v-btn>
                </div>
            </v-card>
        </v-dialog>

    </div>
</template>


<script>
import ModEdit from '../programas/modulo_edit.vue';
import { error } from '@/components/Utils.js';
import psessiones from '@/components/APrograma-sessiones.vue';
import Calendario from '@/views/programas/modulo-calendario.vue'
import gql from 'graphql-tag';
import xaxios from '@/xaxios';

export default {
    components:{
        ModEdit,
        psessiones,
        Calendario
    },
    data() {
        return {
            e6: 1,
            dialog: false,
            loading: false,
            issessiondis: false,
            modulo: {},
            programa: {},
            headers: [
                { text: '#', value: 'nro' },
                { text: 'Nombre clase', value: 'Nombre_session' },
                { text: 'Ingreso', value: 'Ingreso' },
                { text: 'Salida', value: 'Salida' }, 
            ],
            desserts: [],
        }
    },
    methods:{
        opensessiones(item){
          if( !this.issessiondis ){
            this.$notify(error('Denegado', 'Acceso denegado a esta opcion.'));
          }else{
            this.$refs.psessiones.openmodal(item);
          }
        },
        parsefecha(f) {
            if (!f) return;
            let fs = f.split(' ');
            let hour = fs[1].split(':');
            let date = fs[0].split('-');
            return `${hour[0]}:${hour[1]} ${date[2]}/${date[1]}/${date[0]}`;
        },
        openCalendario(){
            this.dialog = true;
            const vue = this;
            setTimeout(() => {
                vue.$refs.refcalendario.openmodal(vue.desserts);
            }, 400);
        },
        async getDataPrograma(programaid){
            let programa_modulo_id = this.$route.query.programa_modulo_id;
            let sql = gql`query{ getPrograma(id:${programaid}){id,version,nombre_compuesto,programa_modulos{id,course_id,modulo{id,nombre},docente{nombres,pri_apellido,seg_apellido},numero,inicio,fin,puntuacion,estado}} }`;
            let res = await this.$apollo.query({ query: sql }).then((data) => data).catch((e)=>e);
            this.programa = res.data.getPrograma;
            let mods = res.data.getPrograma.programa_modulos;
            this.modulo = mods.find( x=>x.id==programa_modulo_id );
            if(this.modulo) this.getHorarios();
            window.console.log(this.modulo);
        },
        async getHorarios(){
            if(!this.modulo) return;
            let modid = this.modulo.id;
            this.desserts = [];
            let urlc = `${process.env.VUE_APP_API_REST}/api/v1/sessiones/moduloid/${modid}`; 
            this.loading = true;
            let res = await xaxios.get(urlc).then((data) => data);
            res.data.data.map((x, i) => {
                x.nro = i + 1;
                x.Ingreso = this.parsefecha(x.Ingreso);
                x.Salida = this.parsefecha(x.Salida);
            });
            this.desserts = res.data.data;
            this.loading = false;
        }
    },
    mounted(){
        this.issessiondis = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 8 || this.$store.state.CARGO.id == 6 || this.$store.state.CARGO.id == 7;
        let programaid = this.$route.query.programa_id; 
        this.getDataPrograma(programaid);
    }
}
</script>